import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadChildren: () => import('./routing-module/routes/routes.module').then(m => m.RoutesModule) }
];